import React, { useMemo, useState, useEffect } from "react";
import "./PageHeader.css";
import { Select, Spin, message } from "antd";
import axios from "axios";
import { useConfigQuery } from "../../../queries/useConfig";

const { Option } = Select;

const onlyDigits = (v = "") => String(v).replace(/\D/g, "");
const normalizeText = (v = "") =>
  String(v)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

const PageHeader = ({
  tabName,
  nomeLoja,
  nomeUsuarioLogado,

  // ✅ agora é ID (string) ou null
  lojaSelecionadaId = null,
  onChangeLoja,

  carregando = false,
}) => {
  const { data: config } = useConfigQuery();

  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);

  const [lojas, setLojas] = useState([]);
  const [loadingLojas, setLoadingLojas] = useState(false);

  const getDataAtual = () => {
    const d = new Date();
    const dia = String(d.getDate()).padStart(2, "0");
    const mes = String(d.getMonth() + 1).padStart(2, "0");
    const ano = d.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  // ✅ busca lojas pelo endpoint quando tiver o CNPJ do responsável fiscal
  useEffect(() => {
    const cnpjResp = config?.restaurante?.cnpj;
    if (!cnpjResp) return;

    const fetchLojas = async () => {
      try {
        setLoadingLojas(true);

        const accessToken = window.localStorage.getItem("accessToken");
        const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined;

        // ⚠️ se isso vai para produção, troque localhost por sua base da API
        const url = `https://apitestecontabil.techspdv.com.br/integracao/restaurantes?cnpjResponsavelFiscal=${encodeURIComponent(
          cnpjResp
        )}`;

        const res = await axios.get(url, { headers });
        const data = Array.isArray(res.data) ? res.data : [];
        setLojas(data);

        // ✅ se o ID selecionado não existir mais na lista, limpa
        if (lojaSelecionadaId) {
          const existe = data.some((l) => String(l.id) === String(lojaSelecionadaId));
          if (!existe) onChangeLoja?.(null);
        }
      } catch (err) {
        console.error(err);
        setLojas([]);
        message.error("Erro ao carregar lojas do responsável fiscal.");
      } finally {
        setLoadingLojas(false);
      }
    };

    fetchLojas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config?.restaurante?.cnpj]);

  // abre dropdown quando começa a digitar (se não estiver carregando)
  useEffect(() => {
    if (search && !carregando) setOpen(true);
  }, [search, carregando]);

  const lojasFiltradas = useMemo(() => {
    const sRaw = String(search || "").trim();
    if (!sRaw) return lojas;

    const sDigits = onlyDigits(sRaw);
    const sNorm = normalizeText(sRaw);

    return lojas.filter((l) => {
      const nomeNorm = normalizeText(l?.nome || "");
      const cnpjDigits = onlyDigits(l?.cnpj || "");

      if (sDigits.length > 0) return cnpjDigits.includes(sDigits);
      return nomeNorm.includes(sNorm);
    });
  }, [lojas, search]);

  // opcional: loja selecionada (objeto) caso queira exibir em algum lugar
  // const lojaSelecionadaObj = useMemo(() => {
  //   if (!lojaSelecionadaId) return null;
  //   return lojas.find((l) => String(l.id) === String(lojaSelecionadaId)) || null;
  // }, [lojas, lojaSelecionadaId]);

  return (
    <div className="page-header-container">
      <div className="page-header">
        {/* ESQUERDA */}
        <div className="ph-left">
          <div className="ph-tab">{tabName}</div>
          <div className="ph-date">{getDataAtual()}</div>
        </div>

        {/* CENTRO */}
        <div className="ph-center">
          <div className="ph-loja">{nomeLoja}</div>
        </div>

        {/* DIREITA */}
        <div className="ph-right">
          <div className="ph-user">{nomeUsuarioLogado}</div>

          <div className="ph-select">
            {loadingLojas ? (
              <Spin size="small" />
            ) : (
              <Select
                value={lojaSelecionadaId ?? undefined}
                style={{ width: 360 }}
                placeholder="Selecione uma loja"
                showSearch
                searchValue={search}
                onSearch={(val) => setSearch(val)}
                open={open}
                onDropdownVisibleChange={(v) => setOpen(v)}
                filterOption={false}
                autoClearSearchValue={false}
                allowClear
                disabled={carregando || !lojas?.length}
                notFoundContent={search ? "Nenhuma loja encontrada" : "Sem lojas"}
                placement="bottomRight"
                onClear={() => {
                  onChangeLoja?.(null);
                  setSearch("");
                  setOpen(false);
                }}
                onChange={(id) => {
                  if (!id || id === "__blank__") {
                    onChangeLoja?.(null);
                    setSearch("");
                    setOpen(false);
                    return;
                  }

                  const lojaObj = lojas.find((l) => String(l.id) === String(id)) || null;

                  const resumo = lojaObj
                    ? {
                      id: String(lojaObj.id),
                      nome: String(lojaObj.nome || ""),
                      cnpj: String(lojaObj.cnpj || ""),
                    }
                    : null;

                  onChangeLoja?.(resumo);

                  setOpen(false);
                  setSearch("");
                }}
              >
                <Option key="__blank__" value="__blank__">
                  — Nenhuma loja —
                </Option>

                {lojasFiltradas.map((l) => (
                  <Option key={l.id} value={l.id}>
                    {l.nome} {l.cnpj ? `— ${l.cnpj}` : ""}
                  </Option>
                ))}
              </Select>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;